/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSyncValues} from '../api'

 export const useQueryGetSyncValues = createReactQueryHook('getSyncValues', getSyncValues)
